import React, { useState } from 'react';
import { Star, Minus, ChevronDown } from 'lucide-react';

const mockReviews = [
  {
    id: 1,
    name: 'Joe C.',
    date: '6 months ago',
    avatar: '/testimonials/joe.webp',
    content:
      "Embarking on a personal training program can be a life-changing decision, and my experience with the Elyte Personal Training Program has been nothing short of remarkable. From the personalized guidance of Olu to the comprehensive approach, this program has pushed me to my limits and helped me achieve my fitness goals. I started my journey in December of 2022 and as of June 2023 I've lost 50lbs!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Xtina C.',
    date: '4 months ago',
    avatar: '/testimonials/xtina.webp',
    content:
      "Olu is extremely professional! He is attentive and listens to his clients wants and needs, then customizes programming accordingly. His training style is unique, and offers a level of responsiveness that is unmatched. I would highly recommend Elyte and Olu to meet and surpass all of your fitness goals!",
    rating: 5,
  },
  {
    id: 3,
    name: 'Melissa P.',
    date: '3 months ago',
    avatar: '/testimonials/melissa.webp',
    content:
      "Olu has been very encouraging and takes the time to listen and explore all aspects of health and fitness to make the best choices for my goals. He works WITH you and not against you- so if going to a gym isn't your thing, Olu will make your goals happen with what works for you.",
    rating: 5,
  },
  {
    id: 4,
    name: 'Temi O.',
    date: '5 months ago',
    avatar: '/testimonials/temi.webp',
    content:
      "Coach Olu is the best! He's very passionate about what he does and it shows! Thank you for all the great tips and motivation.",
    rating: 5,
  },
  {
    id: 5,
    name: 'Victor O.',
    date: '4 months ago',
    avatar: '/testimonials/victor.webp',
    content:
      "Communication was seamless throughout the entire training process. Olu was always available to answer any questions, provide guidance, and offer valuable insights. He had a deep understanding of exercise science, nutrition, and various training techniques. From the very beginning, he took the time to understand my fitness goals, limitations, and preferences, tailoring a program specifically for me. Would recommend to anyone looking into online fitness coaching!",
    rating: 5,
  },
  {
    id: 6,
    name: 'Dreah Kay',
    date: '3 months ago',
    avatar: '/testimonials/Dreah.webp',
    content:
      "Olu is a very caring trainer and he truly caters to your individual needs. He put the focus solely on your goals and what you wish to achieve and he then create the perfect plan for you. He's available to chat when you need him and he never make you feel rushed or unimportant. I'm in Michigan, so I'm miles away from him, But he makes me feel close. Thank you Olu!",
    rating: 5,
  },
  {
    id: 7,
    name: 'Naiya',
    date: '2 months ago',
    avatar: '/testimonials/Naiya.webp',
    content:
      "I started with Elyte a few months back the program helped me keep a routine reset my mindset and Olu is a great coach he helps motivate the mind to have a new start he is so aware of the body and how to reset into a new pattern. Now I am on my own holding the pattern myself and focusing on my goals he really cares about what he does and his passionate help others live a healthy lifestyle certainly rubbed off on me. I am grateful for the push and the new mind patterns he passed to me looking forward to this new me thanks Olu. I will certainly pass the word about your program to others who are looking for the new them because it works thank you again!",
    rating: 5,
  },
  {
    id: 8,
    name: 'Faye B.',
    date: '3 months ago',
    avatar: '/testimonials/Faye.webp',
    content:
      "Absolutely loved working with Coach Olu! He's patient, answers any questions I throw his way and you can tell he truly cares about his clients and wants so much for us to achieve our goals",
    rating: 5,
  },
  {
    id: 9,
    name: 'Denzel C.',
    date: '4 months ago',
    avatar: '/testimonials/Denzel.webp',
    content:
      "Olu is an excellent coach, follow his programming and his advice and you will get results. It is really up to you how fast that happens because he provides you with all of the tools. He will provide you with the motivation as well!",
    rating: 5,
  },
  {
    id: 10,
    name: 'Michelle G.',
    date: '2 months ago',
    avatar: '/testimonials/Michelle.webp',
    content:
      "I love working with Olu. He is extremely well versed in all aspects of physical fitness. From physical exercises to nutrition. He listens when you speak and asks questions that helps him understand who you are as an individual. By doing so it allows him to come up with a workout plan that perfectly fitted to you and your lifestyle. He lives and breaths fitness. It's something that excites him and pushes him to keep learning. He is always on your side. Rooting for you. Thank you Olu for doing what you do! You're the best!!",
    rating: 5,
  }
];

function getInitials(name) {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
}

const GoogleSVG = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill="#4285f4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34a853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#fbbc05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path fill="#ea4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

const GoogleReviews = () => {
  const [open, setOpen] = useState(false);
  const [minimized, setMinimized] = useState(false);

  if (minimized) {
    return (
      <div className="fixed bottom-4 left-4 z-50">
        <button
          onClick={() => setMinimized(false)}
          className="bg-white rounded-lg shadow-md border p-2 hover:shadow-lg transition-all duration-200 opacity-90 hover:opacity-100 flex items-center gap-2"
        >
          <GoogleSVG size={20} />
          <div className="flex items-center">
            <span className="text-orange-500 font-semibold text-sm mr-1">5.0</span>
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={12} fill="#fa7d09" color="#fa7d09" className="-ml-0.5" />
              ))}
            </div>
          </div>
        </button>
      </div>
    );
  }

  return (
    <div
      className="fixed bottom-4 left-4 z-50"
      style={{ 
        minWidth: open ? 280 : 180, 
        maxWidth: 320,
        fontSize: '13px'
      }}
    >
      <div
        className="bg-white rounded-lg shadow-md border flex flex-col transition-all duration-300"
        style={{ minHeight: open ? 160 : 60 }}
      >
        {/* Header with minimize button */}
        <div className="flex items-center justify-between p-3 border-b border-gray-100">
          <div 
            className="flex items-center gap-2 flex-1 cursor-pointer"
            onClick={() => setOpen((v) => !v)}
          >
            <GoogleSVG size={16} />
            <div className="flex items-center gap-1">
              <span className="text-orange-500 font-semibold text-lg">5.0</span>
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={12} fill="#fa7d09" color="#fa7d09" className="-ml-0.5" />
                ))}
              </div>
            </div>
            {/* <span className="text-xs text-gray-600 font-medium ml-1">14 reviews</span> */}
            <ChevronDown 
              size={14} 
              className={`text-gray-400 transition-transform duration-200 ml-1 ${open ? 'rotate-180' : ''}`} 
            />
          </div>
          <button
            onClick={() => setMinimized(true)}
            className="p-1 hover:bg-gray-100 rounded transition-colors duration-150"
          >
            <Minus size={12} className="text-gray-400" />
          </button>
        </div>

        {/* Expanded reviews */}
        {open && (
          <div className="px-3 pb-3 pt-2 bg-white max-h-[36rem] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            {mockReviews.map((review) => (
              <div key={review.id} className="flex gap-2 py-3 border-b last:border-b-0 border-gray-100">
                {review.avatar ? (
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-8 h-8 rounded-full object-cover flex-shrink-0"
                  />
                ) : (
                  <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-xs font-bold text-white flex-shrink-0">
                    {getInitials(review.name)}
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-semibold text-gray-900 text-xs truncate">{review.name}</span>
                    <span className="text-xs text-gray-500 flex-shrink-0">{review.date}</span>
                    <GoogleSVG size={12} />
                  </div>
                  <div className="flex items-center mb-2">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} size={10} fill="#000" color="#000" />
                    ))}
                  </div>
                  <div className="text-gray-800 text-xs leading-relaxed">
                    {review.content}
                  </div>
                </div>
              </div>
            ))}
            <div className="pt-3 border-t border-gray-100">
              <a
                href="https://www.google.com/search?newwindow=1&sca_esv=8a70c10f7ae50c33&cs=0&output=search&kgmid=/g/11trh6882y&q=Elyte+Fitness&shndl=30&shem=dlce1,lcuae,lspt14,uaasie&source=sh/x/loc/uni/m1/1&kgs=9c44a1a3843bfff8#lrd=0x2f5131e072e8b89f:0x1bb92c164bd1fc41,1,,,,"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 text-xs font-medium flex items-center gap-1"
              >
                See all 14 reviews on Google
                <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 17L17 7M17 7H8M17 7V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GoogleReviews; 